import React from 'react';
import {Row, Col} from 'react-bootstrap';

export default function BudgetTable({
  groupId, 
  budgetScopes,
  bands,
  fteDivisor
}) {
  const renderBudgetScopes = () => {
    let budgetScopeRows = [];
    let totalManHours = 0;
    let totalManDays = 0;
    let percentage = 0;
    let totalPercentage = 0;
    let totalFTE = 0;

    //get total man hours
    budgetScopes.length && budgetScopes.filter(data => {
      if (!['F', 'G'].includes(data.band_group)) {
        return data;
      }
      return false;
    }).forEach(budgetScope => {
      totalManHours += +budgetScope.manhours;
      totalManDays += +budgetScope.mandays;
    })

    let fte = 0;
   
    budgetScopeRows = budgetScopes.length ? budgetScopes.filter(data => {
      if (!['F', 'G'].includes(data.band_group)) {
        return data;
      }
      return false;
    }).map(budgetScope => {
      if (budgetScope.manhours) {
        fte = budgetScope.mandays / fteDivisor;
        totalFTE += fte;
        percentage = (budgetScope.manhours / totalManHours) * 100;
      }
      else {
        percentage = 0;
        fte = 0;
      }
      
      totalPercentage += percentage;
     
      return (
        <Row>
          <Col xs={3} sm={3} md={3} lg={3} xl={3} className="align-left">Band {budgetScope.band_group}</Col>
          <Col xs={2} sm={2} md={2} lg={2} xl={2} className="align-right">
            <span className={"budget-mandays-" + groupId}>
              {budgetScope.mandays.toFixed(2)}
            </span>
          </Col>
          <Col xs={2} sm={2} md={2} lg={2} xl={2} className="align-right">
            <span className={"budget-manhours-" + groupId}>
              {budgetScope.manhours.toFixed(2)}
            </span>
          </Col>
          <Col xs={2} sm={2} md={2} lg={2} xl={2} className="align-right">
            <span className={"budget-percentage-" + groupId}>
              {percentage.toFixed(2)}%
            </span>
          </Col>
          <Col xs={2} sm={2} md={2} lg={2} xl={2} className="align-right">
            <span className={"budget-fte-" + groupId}>
              {fte.toFixed(2)}
            </span>
          </Col>
        </Row>
      )
    }) : (
      <>
       { bands.length ? bands.map(band => {
         return (
           <Row>
            <Col className="align-left">Band {band}</Col>
           </Row>
         )
       }) : ''}
      </>
    )

    budgetScopeRows.length && budgetScopeRows.push(
      <Row>
        <Col xs={3} sm={3} md={3} lg={3} xl={3} className="align-left">
          Total
        </Col>
        <Col xs={2} sm={2} md={2} lg={2} xl={2} className="align-right">
          <span className={"budget-mandays-" + groupId}>
            {totalManDays.toFixed(2)}
          </span>
          
        </Col>
        <Col xs={2} sm={2} md={2} lg={2} xl={2} className="align-right">
          <span className={"budget-manhours-" + groupId}>
            {totalManHours.toFixed(2)}
          </span>
        </Col>
        <Col xs={2} sm={2} md={2} lg={2} xl={2} className="align-right">
          <span className={"budget-percentage-" + groupId}>
            {totalPercentage.toFixed(2)}% 
          </span>
         
        </Col>
        <Col xs={2} sm={2} md={2} lg={2} xl={2} className="align-right">
          <span className={"budget-fte-" + groupId}>
            {totalFTE.toFixed(2)}
          </span>
        </Col>
      </Row>
    )
    return budgetScopeRows;
  }
  return (
    <>
      <Row>
        <Col xs={3} sm={3} md={3} lg={3} xl={3}></Col>
        <Col xs={2} sm={2} md={2} lg={2} xl={2} className="align-right">Mandays</Col>
        <Col xs={2} sm={2} md={2} lg={2} xl={2} className="align-right">Manhours</Col>
        <Col xs={2} sm={2} md={2} lg={2} xl={2} className="align-right">Percentage</Col>
        <Col xs={2} sm={2} md={2} lg={2} xl={2} className="align-right">FTE</Col>
      </Row>
      {renderBudgetScopes()}
    </>
  )
}
